// HTTP client com JWT em localStorage. Sempre injeta Bearer token quando há.
// Em 401, dispara evento global pra forçar logout (router pega).
const TOKEN_KEY = 'cglogs.token';
export function getToken() {
    return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t) {
    if (t)
        localStorage.setItem(TOKEN_KEY, t);
    else
        localStorage.removeItem(TOKEN_KEY);
}
export class ApiError extends Error {
    status;
    body;
    constructor(status, body, message) {
        super(message);
        this.status = status;
        this.body = body;
    }
}
export async function api(path, init = {}) {
    const headers = new Headers(init.headers);
    if (!headers.has('content-type') && init.body && typeof init.body === 'string') {
        headers.set('content-type', 'application/json');
    }
    const t = getToken();
    if (t)
        headers.set('authorization', `Bearer ${t}`);
    const res = await fetch(path.startsWith('http') ? path : `/api${path}`, { ...init, headers });
    if (res.status === 401) {
        setToken(null);
        window.dispatchEvent(new CustomEvent('cglogs:unauthorized'));
        throw new ApiError(401, null, 'unauthorized');
    }
    let body = null;
    const ct = res.headers.get('content-type') ?? '';
    if (ct.includes('application/json'))
        body = await res.json();
    else if (ct.startsWith('text/'))
        body = await res.text();
    if (!res.ok) {
        const msg = body?.error ?? `HTTP ${res.status}`;
        throw new ApiError(res.status, body, msg);
    }
    return body;
}
export const apiGet = (path) => api(path);
export const apiPost = (path, data) => api(path, { method: 'POST', body: JSON.stringify(data) });
export const apiPatch = (path, data) => api(path, { method: 'PATCH', body: JSON.stringify(data) });
export const apiDelete = (path) => api(path, { method: 'DELETE' });
